export default "__VITE_ASSET__C_qNyvH1__"